import type { components } from "@appretio/api";
import { isEditableIntakeSource } from "../components/cubeDataTable/utils/intakeUtils";
import type { ForecastTableControlValues } from "../components/tableControls/forecastTableControlValues";
import type { ForecastGridDataOutput } from "../hooks/useFetchForecastData";

type TransactionalGridData = components["schemas"]["TransactionalGridData"];

/**
 * Returns the rows whose metric a save may persist in `intake` mode: the
 * irreducible sales and stock metrics always, the intake metrics only for an
 * editable source (Planned), where they are the planner's own rather than the
 * warehouse's orders (Confirmed, ETA) that a write would lose.
 */
export function filterSaveableRows(
  rows: TransactionalGridData[],
  forecastData: ForecastGridDataOutput | null,
  intake: ForecastTableControlValues["intake"]
): TransactionalGridData[] {
  const baseMetrics = forecastData?.irreducible_sales_and_stock_metrics;
  if (!baseMetrics) return rows;
  const saveable = new Set(baseMetrics);
  if (isEditableIntakeSource(intake)) {
    forecastData?.irreducible_intake_metrics?.forEach((m) => saveable.add(m));
  }
  return rows.filter((row) => saveable.has(row.metric_name));
}
